<template>
  <div class="knowledge-center-new dashboard-card dashboard-card-lt mt-4">
    <div class="knowledge_head">
      <div
        class="d-flex dashboard-knowledge-title align-items-center justify-content-between"
      >
        <h3>Knowledge Center</h3>
        <button
          class="view-all-knowledge"
          @click="() => $router.push({ name: 'ViewKnowledge' })"
        >
          View All
        </button>
      </div>
      <!-- <router-link :to="{ name: 'ViewKnowledge' }"
        ><small>View All</small></router-link
      > -->
    </div>

    <!-- the skeleton loader for UI while waiting for data -->
    <b-skeleton-table
      v-if="skeletonLoader"
      :rows="5"
      :columns="2"
      :table-props="{ bordered: true, striped: true }"
    ></b-skeleton-table>
    <div class="dashboard-knowledge-body" v-if="!skeletonLoader">
          <div class="text-center" v-if="checkRowLength()">
           No results found
         </div>
      <ul class="knowledge-preview-list">
        <template v-for="(item, index) in knowledge_feeds.slice(0, 10)">
          <li class="knowledge-item" :key="index" @click="$bvModal.show('knowledge_modal_' + item.id)"
>
            <div class="knowledge-icon">
              <img
                src="@/assets/images/message-icon.svg"
                alt="Knowledge Icon"
              />
            </div>
            <div class="knowledge-content">
              <div class="knowledge-title">{{item.title}}</div>
              <!-- <div class="knowledge-snippet"><p v-html="item.description"/></div> -->
            </div>
            <div class="knowledge-meta text-end">
              <div class="knowledge-author">{{ item.source}}</div>
              <div class="knowledge-date">{{ item.published_date}}</div>
            </div>
          </li>
          <!-- Render hr only if it's not the last item -->
          <hr
            v-if="index < knowledge_feeds.slice(0, 10).length - 1"
            class="knowledge-item-ruler"
            :key="index"
          />
        </template>
      </ul>

      <!-- old code  -->
      <!-- <div
        class="msg-list"
        v-for="(item, index) in knowledge_feeds"
        :key="index"
      >
        <div class="message">
          <p>{{ formatTitle(item.title) }}</p>
          <small>{{ formatDate(item.published_date) }}</small>
        </div>
        <button
          @click="$bvModal.show('knowledge_modal_' + item.id)"
          class="read"
        >
          Read More
        </button>
      </div> -->
    </div>
    <!-- <a class="view" href="#">View All</a> -->

    <b-modal
      v-for="(item, index) in knowledge_feeds"
      :key="index"
      :title="item.title"
      :id="'knowledge_modal_' + item.id"
      class="message_modal new_one"
      :centered="true"
      :hide-footer="true"
      size="lg"
    >
      <div class="modal-body">
        <div class="rcv-msgcontent">
          <div class="rcv-msg-sender">
            <div class="rcv-snder-icon">
              <img
                :src="item?.created_user?.agent_profile_image ?? $dummyImage"
                alt=""
                class="msg-userIcon"
              />
              <div class="rcv-sender-details">
                <h6>{{ item?.created_user?.rep_full_name ?? "ADMIN" }}</h6>
                <p>
                  <i class="far fa-calendar-alt"></i>
                  {{
                    item.published_date
                      | date_format(
                        "YYYY-MM-DD",
                        "MM/DD/YYYY",
                        item.published_date
                      )
                  }}
                </p>
              </div>
            </div>
          </div>
          <h5>Title: {{ item.title }}</h5>
          <hr />
          <div class="ql-snow">
            <div class="ql-editor">
              <p v-html="item.description" />
            </div>
          </div>
          <div v-if="item.file && item.file.length > 0">
            <h6>Attachments:</h6>
            <ul style="list-style: none">
              <li v-for="file in item.file" :key="file.id">
                <a :href="file.path" target="__blank" download>
                  <i class="fa fa-file"></i>
                  {{ file.filename }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="modal-footer"></div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import helper from "../../resource/Helper";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      knowledge_feeds: [],
      skeletonLoader: true,
    };
  },
  computed: {
    ...mapGetters(["activePlanId"]),
  },
  mounted() {
    this.getKnowledgeFeed();
  },
  methods: {
    getKnowledgeFeed() {
      return axios
        .get(
          process.env.VUE_APP_CORENROLL_SYSTEM_API_V2 +
          "knowledge-feed/merged-feed")
        .then((response) => {
          this.knowledge_feeds = response.data.data;
          this.skeletonLoader = false;
        })
        .error((err) => {});
    },

     checkRowLength() {
      if (this.knowledge_feeds.length < 1) {
        return true;
      } else {
        return false;
      }
    },
    
    formatDate(date) {
      return helper.formatDate(date);
    },
    formatTitle(title) {
      return title.length > 30 ? title.substr(0, 30) + "..." : title;
    },
    downloadFile(file) {
      window.open(process.env.VUE_APP_CORENROLL_KNOWLEDGE_CENTER_FILE + file);
    },
  },
};
</script>
<style scoped>
/* title and view all btn */
.knowledge-center-new .dashboard-knowledge-title {
  margin-bottom: 2rem;
}
.knowledge-center-new .dashboard-knowledge-title h3 {
  margin: 0;
}
.knowledge-center-new .dashboard-knowledge-title .view-all-knowledge {
  background-color: #29bcff;
  color: #fff;
  padding: 6px 5px;
  padding-bottom: 6px;
  font-weight: 700;
  padding-bottom: 5px;
  font-size: 13px;
  border-radius: 3px;
  border: 1px solid #29bcff;
}
/* table items  */
.knowledge-preview-list {
  max-height: 282px;
  overflow-y: auto;
  padding: 0 10px;
  margin: 0;
}
.knowledge-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.knowledge-item-ruler {
  margin: 0.5rem 0;
  border: none;
  border-top: 1px solid #e2e2e2;
}
.knowledge-preview-list .knowledge-icon {
  width: 30px;
}
.knowledge-preview-list .knowledge-icon img {
  width: 100%;
}
.knowledge-content {
  flex: 1;
  min-width: 0;
  cursor: pointer;
}
.knowledge-content .knowledge-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.knowledge-content .knowledge-snippet {
  font-size: 14px;
  font-weight: 400;
  color: #767676;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.knowledge-meta {
  flex-shrink: 0;
  text-align: right;
  margin-left: auto;
}
.knowledge-meta .knowledge-author,
.knowledge-meta .knowledge-date {
  font-size: 14px;
}
.knowledge-meta .knowledge-author {
  font-weight: 700;
  margin-bottom: 0.25rem;
  color: #29bcff;
}
.knowledge-meta .knowledge-date {
  font-weight: 400;
  color: #767676;
}
@media (max-width: 1200px) {
  .knowledge-preview-list .knowledge-icon {
    width: 40px;
    height: auto;
  }
}
@media (max-width: 992px) {
  .knowledge-preview-list .knowledge-icon {
    width: 36px;
    height: auto;
  }
}
</style>
